export default "__VITE_ASSET__CmT5bPU7__"